import loadable from 'Utils/loadable';

export default loadable(() => import('./Oauth2AppEdit'));
